import type { ReactElement } from 'react';

import { cx } from './cx';
import styles from './Spinner.module.css';

export interface SpinnerProps {
  /** Diameter in px (default 32). */
  size?: number;
  /** Spoken name; omit when a visible label already says what is loading. */
  label?: string;
  className?: string;
}

/**
 * A ring that turns in the current text colour. Pure CSS (a `transform` animation the TV's
 * compositor runs without the main thread), so it keeps moving while the JS thread is busy
 * parsing the next screen.
 */
export function Spinner({ size = 32, label, className }: SpinnerProps): ReactElement {
  const border = Math.max(2, Math.round(size / 9));
  return (
    <span
      className={cx(styles.spinner, className)}
      style={{ width: size, height: size, borderWidth: border }}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      data-testid="spinner"
    />
  );
}
